import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'main-component',
  imports: [FormsModule, RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class MainComponent {

}
